import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onToggle }) => {
  const filterOptions = {
    industry: [
      'All Industries',
      'Healthcare',
      'Financial Services',
      'Manufacturing',
      'Retail',
      'Technology',
      'Education'
    ],
    companySize: [
      'All Sizes',
      'Enterprise',
      'Mid-Market',
      'SMB'
    ],
    useCase: [
      'All Use Cases',
      'Platform Migration',
      'Cost Optimization',
      'Capability Building',
      'Vendor Independence',
      'Performance Enhancement'
    ],
    transformationType: [
      'All Types',
      'Full Migration',
      'Hybrid Approach',
      'Greenfield Implementation',
      'Legacy Modernization'
    ]
  };

  const handleFilterChange = (category, value) => {
    onFilterChange(category, value === `All ${category?.charAt(0)?.toUpperCase() + category?.slice(1)}` || value === 'All Industries' || value === 'All Sizes' || value === 'All Use Cases' || value === 'All Types' ? '' : value);
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters)?.filter(value => value !== '')?.length;
  };

  return (
    <>
      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-6">
        <Button
          variant="outline"
          onClick={onToggle}
          iconName="Filter"
          iconPosition="left"
          className="w-full"
        >
          Filters {getActiveFiltersCount() > 0 && `(${getActiveFiltersCount()})`}
        </Button>
      </div>
      {/* Filter Panel */}
      <div className={`bg-white rounded-xl shadow-executive border border-gray-200 p-6 ${isOpen ? 'block' : 'hidden lg:block'}`}>
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-text-primary flex items-center">
            <Icon name="Filter" size={20} className="mr-2" />
            Filters
          </h3>
          {getActiveFiltersCount() > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              className="text-text-secondary hover:text-text-primary"
            >
              Clear All
            </Button>
          )}
        </div>

        <div className="space-y-6">
          {Object.entries(filterOptions)?.map(([category, options]) => (
            <div key={category}>
              <h4 className="text-sm font-medium text-text-primary mb-3 capitalize">
                {category === 'useCase' ? 'Use Case' : category === 'companySize' ? 'Company Size' : category === 'transformationType' ? 'Transformation Type' : category}
              </h4>
              <div className="space-y-2">
                {options?.map((option) => (
                  <label
                    key={option}
                    className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200"
                  >
                    <input
                      type="radio"
                      name={category}
                      value={option}
                      checked={
                        (option?.startsWith('All') && filters?.[category] === '') ||
                        filters?.[category] === option
                      }
                      onChange={(e) => handleFilterChange(category, e?.target?.value)}
                      className="w-4 h-4 text-brand-primary border-gray-300 focus:ring-brand-primary focus:ring-2"
                    />
                    <span className="ml-3 text-sm text-text-secondary">
                      {option}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Quick Filters */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <h4 className="text-sm font-medium text-text-primary mb-3">Quick Filters</h4>
          <div className="flex flex-wrap gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onFilterChange('transformationType', 'Full Migration');
                onFilterChange('useCase', 'Platform Migration');
              }}
              className="text-xs"
            >
              Platform Migrations
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onFilterChange('companySize', 'Enterprise');
                onFilterChange('useCase', 'Cost Optimization');
              }}
              className="text-xs"
            >
              Enterprise Cost Savings
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onFilterChange('useCase', 'Vendor Independence');
              }}
              className="text-xs"
            >
              Vendor Independence
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;